export const checkIfInMobileView = () => {
  if (window.innerWidth <= 768) {
    return true;
  }

  return false;
};
